<i18n locale="en">
{
  "actions": {
    "confirm": "Save Image"
  },
  "input": {
    "label": "Image Source",
    "description": "Where did you get this image from?"
  },
  "dialogs": {
    "title": "Save Image"
  }
}
</i18n>
<template>
  <ConfirmDialog
    :model-value="modelValue"
    :title="t('dialogs.title')"
    :confirm-label="t('actions.confirm')"
    :processing="processing"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
  >
    <div class="flex-col gap-3">
      <OwnInputContainer
        :label="t('input.label')"
        :description="t('input.description')"
      >
        <OwnSelect
          :model-value="selectedSource"
          :options="computedSourceOptions"
          :placeholder="$t('image-sources.customer-web')"
          @update:model-value="$emit('update:selectedSource', $event)"
        />
      </OwnInputContainer>
    </div>
  </ConfirmDialog>
</template>
<script lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { OwnSelect } from '@/ui/OwnSelect'

export default {
  name: 'ImageSourceDialog',
  components: {
    ConfirmDialog,
    OwnInputContainer,
    OwnSelect,
  },
  emits: ['update:modelValue', 'update:selectedSource', 'confirm', 'cancel'],
  setup() {
    const { t } = useI18n()

    const computedSourceOptions = computed(() => [
      { label: t('image-sources.customer-web'), value: 'customer-web' },
      { label: t('image-sources.freepik'), value: 'freepik' },
      { label: t('image-sources.third-party-dd'), value: 'third-party-dd' },
      { label: t('image-sources.third-party-gh'), value: 'third-party-gh' },
      {
        label: t('image-sources.third-party-other'),
        value: 'third-party-other',
      },
      { label: t('image-sources.third-party-ue'), value: 'third-party-ue' },
      { label: t('image-sources.slice'), value: 'slice' },
      { label: t('image-sources.snappr'), value: 'snappr' },
      { label: t('image-sources.unknown'), value: 'unknown' },
    ])

    return { computedSourceOptions, t }
  },
  props: {
    modelValue: { type: Boolean, default: false },
    processing: { type: Boolean, default: false },
    selectedSource: { type: String, default: 'customer-web' },
  },
}
</script>
